import React, { useRef, useState, useCallback } from "react";
import "./style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const NewTestimonials = ({ shortHeading, mainHeading, description, content }) => {
  const sliderRef = useRef();

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  // TESTIMONIAL CONTENT
  const { t } = useTranslation("testimonials");
  const testimonials = t("testimonialArray", { returnObjects: true });
  const testimonialsContent = t("testimonialContent", { returnObjects: true });

  return (
    <>
      <section className="new-testimonials-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="new-testomonial-text-box">
                <h2 className="low-top-white-heading">{shortHeading}</h2>
                <p
                  className="capital-main-white-heading"
                  dangerouslySetInnerHTML={{ __html: mainHeading }}
                />
                <p className="description-white-text" dangerouslySetInnerHTML={{ __html: description }} ></p>
              </div>
            </div>
          </div>

          <Swiper
            slidesPerView={"1"}
            spaceBetween={0}
            navigation={false}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            modules={[Navigation, Autoplay]}
            onSlideChange={handleSlideChange}
            className="mySwiper"
            ref={sliderRef}
          >
            {(content || testimonials)?.map((card, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="row new-testimonial-slider-box">
                    {/* Left: Image */}
                    <div className="col-md-5">
                      <div className="testimonial-img">
                        <img
                          src={card?.profileImage}
                          alt={card?.name}
                        />
                      </div>
                    </div>
                    {/* Right: Content */}
                    <div className="col-md-7 testimonial-main-card-box mt-md-0 text-start">
                      <h4 className="testimonial-name">{card?.name}</h4>
                      <p className="testimonial-role">{card?.designation}</p>
                      {/* Tags */}
                      <div className="testimonial-tags mb-2">
                        <span>{card?.enterprise}</span>
                        <span><img src={card?.countryFlagImage} alt="Flag" /> {card?.country}</span>
                      </div>
                      <div className="testimonial-tags-board">
                        {card?.serviceTags?.map((item, index) => {
                          return <Link to={item?.link} className="text-decoration-none" target="_blank"><span key={index}>{item?.title}</span></Link>
                        })}
                      </div>
                      {/* Testimonial Text */}
                      <p className="testimonial-text">“{card?.text}”</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className="row new-testimonial-slider-arrows">
            <div className="col-md-12">
              {/* Navigation */}
              <div className="testimonial-navigation text-center">
                <span
                  href="#"
                  onClick={handlePrev}
                  className={`left-image ${isBeginning ? "disabled" : ""}`}
                  style={{
                    cursor: isBeginning ? "not-allowed" : "pointer",
                  }}
                >
                  <i class="fa-solid fa-arrow-left me-2"></i> Prev
                </span>
                <span
                  href="#"
                  onClick={handleNext}
                  className={`${isEnd ? "disabled" : ""}`}
                  style={{ cursor: isEnd ? "not-allowed" : "pointer" }}
                >
                  Next <i class="fa-solid fa-arrow-right ms-2"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewTestimonials;
